import React from "react";
import Header1 from "../component/Header1";

const Reviews = () => {
  const reviews = [
    {
      id: 1,
      name: "Sarah J.",
      rating: 5,
      review:
        "Ketobalanced has completely transformed my keto journey! The supplements and support have been a game-changer in helping me reach my goals. Highly recommend it to anyone serious about keto.",
    },
    {
      id: 2,
      name: "David L.",
      rating: 4,
      review:
        "Great products, but I’d love to see more variety in the keto snacks section. Overall, I’m seeing great results.",
    },
    {
      id: 3,
      name: "Emily R.",
      rating: 5,
      review:
        "I’ve tried a few keto supplements before, but Ketobalanced has the best formula. I’ve been on the keto diet for months, and I feel more energized than ever!",
    },
    {
      id: 4,
      name: "John D.",
      rating: 4,
      review:
        "Excellent customer service and fast shipping. The products are great for the keto diet, but I feel like they could offer more options.",
    },
    {
      id: 5,
      name: "Clara P.",
      rating: 5,
      review:
        "Absolutely love Ketobalanced! Their products helped me stay on track with my keto diet, and I've seen great weight loss results.",
    },
    {
      id: 6,
      name: "Mark T.",
      rating: 3,
      review:
        "The products are decent, but I expected better quality considering the price. Still, I appreciate the customer support.",
    },
    {
      id: 7,
      name: "Alice G.",
      rating: 5,
      review:
        "I've been on the keto diet for months, and Ketobalanced products really make it easier to stick to it. Great results so far!",
    },
    {
      id: 8,
      name: "Jake W.",
      rating: 4,
      review:
        "Great products! However, I would love to see more variety in their meal replacement options. Still, very satisfied with the results.",
    },
    {
      id: 9,
      name: "Sophie B.",
      rating: 5,
      review:
        "Ketobalanced has been a game changer! It’s helped me not only stick to the keto diet but also feel more energetic. Love it!",
    },
    {
      id: 10,
      name: "Ryan H.",
      rating: 3,
      review:
        "The products are okay, but they didn’t quite help me as much as I hoped. The taste could be improved too.",
    },
  ];

  return (
    <div className="bg-custombgColor">
      <Header1 />
      <div className="container mx-auto px-4 py-8">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-semibold text-gray-800 tracking-wide">
            What Our Keto Community Says
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            Hear from real Keto enthusiasts who have experienced the power of
            Ketobalanced products.
          </p>
        </div>

        {/* Reviews Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-all duration-300 "
            >
              {/* User Image and Info */}
              <div className="flex items-center mb-4">
                {/* <img
                  src={review.image}
                  alt={review.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-12 h-12 text-gray-600 rounded-full mr-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                    d="M12 4a4 4 0 110 8 4 4 0 010-8zm0 10c-4.418 0-8 1.79-8 4v2h16v-2c0-2.21-3.582-4-8-4z"
                  />
                </svg>

                <div>
                  <h3 className="font-semibold text-lg tracking-wide">
                    {review.name}
                  </h3>
                  <div className="flex items-center mt-1">
                    {Array.from({ length: review.rating }).map((_, idx) => (
                      <svg
                        key={idx}
                        className="w-4 h-4 text-yellow-400"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        stroke="none"
                      >
                        <path d="M12 17.75l-5.69 3.13 1.46-6.05-4.79-4.19 6.16-.54L12 2l2.87 7.05 6.16.54-4.79 4.19 1.46 6.05z" />
                      </svg>
                    ))}
                  </div>
                </div>
              </div>
              {/* Review Content */}
              <p className="text-gray-700 tracking-wide">{review.review}</p>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center bg-btngreenColor py-12">
          <h2 className="text-3xl font-semibold text-btntextColor tracking-wide">
            Ready to Fuel Your Keto Journey?
          </h2>
          <p className="mt-4 text-lg text-headingColor tracking-wide">
            Explore Ketobalanced products and take your keto diet to the next
            level!
          </p>
          <a
            href="https://usa.ketobalanced.com"
            className="mt-4 inline-block px-8 py-3 bg-ftrgreenColor text-white font-semibold rounded-lg hover:bg-green-700 tracking-wide !cursor-pointer"
          >
            Get Started!
          </a>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
